import http, { Http } from '@/lib/http';

export interface Connection {
  createdAt: Date;
  containerId: string;
}

interface Params {
  projectId: string;
}

function getConnectionCtor(http: Http) {
  return async ({ projectId }: Params): Promise<Connection> => {
    const { data } = await http.get(`/projects/${projectId}/integrations/gtm`);
    return data;
  };
}

export const getConnection = getConnectionCtor(http);
